import { FaGoogle } from "react-icons/fa";
import { FiInfo } from "react-icons/fi";
import { useState } from "react";

export const AutocompleteToggle = ({
  enabled,
  onToggle,
  tooltipMessage,
  disabled = false,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const infoIconClasses = disabled
    ? "text-gray-400 cursor-not-allowed"
    : enabled
      ? "text-white hover:text-gray-100"
      : "text-gray-500 hover:text-gray-700";

  return (
    <div className="ml-4 relative inline-block z-10">
      <button
        type="button"
        onClick={onToggle}
        disabled={disabled}
        aria-label={
          disabled
            ? "Autocomplete Disabled"
            : enabled
              ? "Autocomplete On"
              : "Enable Autocomplete"
        }
        className={`
          inline-flex items-center gap-2
          px-3 py-2
          rounded-full
          text-xs font-medium
          transition-all duration-200 ease-in-out
          relative
          ${
            disabled
              ? "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
              : enabled
                ? "bg-blue text-white border-blue hover:bg-blue-600"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          }
        `}
      >
        {/* ICON SWITCH */}
        {enabled ? (
          // When enabled → show FaGoogle
          <FaGoogle
            className={`text-base ${
              disabled ? "text-gray-400" : "text-white"
            }`}
          />
        ) : (
          // When NOT enabled → show Google SVG
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="-3 0 262 262"
            preserveAspectRatio="xMidYMid"
          >
            <path
              d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
              fill="#4285F4"
            />
            <path
              d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
              fill="#34A853"
            />
            <path
              d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
              fill="#FBBC05"
            />
            <path
              d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
              fill="#EB4335"
            />
          </svg>
        )}

        {/* Button Text */}
        <span>
          {disabled
            ? "Autocomplete Unavailable"
            : enabled
              ? "Autocomplete On"
              : "Enable Autocomplete"}
        </span>

        {/* Info Icon */}
        {!disabled && tooltipMessage && (
          <div
            className="relative flex items-center"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <FiInfo className={`ml-1 ${infoIconClasses}`} size={16} />

            {showTooltip && (
              <div className="absolute left-1/2 -translate-x-1/2 top-10 z-50 w-72 rounded-md bg-gray-900 text-white text-xs p-3 shadow-lg">
                {tooltipMessage}
              </div>
            )}
          </div>
        )}
      </button>
    </div>
  );
};